import BaseService from './baseService';

export default class SnowflakeLoadService extends BaseService {
    constructor() {
        super('snowflake-load');
    }

    /**
     * Gets load statuses of scenario tables
     * @param {Object} request - The request containing filter criteria for load statuses.
     * @param {Array<Object>} request.snowflakeScenarioTableStatusKey - Array of Snowflake scenario table status primary keys to filter by.
     * @param {Array<number>} request.scenarioIds - Array of scenario IDs to filter by.
     * @param {Array<string>} request.statuses - Array of statuses to filter by.
     * @param {Array<number>} request.tableIds - Array of table IDs to filter by.
     * @returns List of loaded tables.
     */
    getLoadStatuses = (request: Partial<{
        snowflakeScenarioTableStatusKey: { scenarioId: number; tableId: number }[];
        scenarioIds: number[]
        statuses: string[];
        tableIds: number[];
    }>) => this.httpGetRequest(`statuses?${this.generateQueryString(request)}`);

    /**
     * Loads Snowflake tables
     * @param {Array<Object>} request - Array of SnowflakeScenarioTableStatusKey
     * @param {Object} request.SnowflakeScenarioTableStatusKey - The list of Snowflake scenario table status keys to load.
     * @returns void
     */
    loadTables = (request: { scenarioId: number; tableId: number }[]) => this.httpPostRequest('tables', request);

    /**
     * Loads all available tables for the specified scenarios into Snowflake.
     * @param {Array<number>} scenarioIds - Array of scenario id
     * @returns void
     */
    loadAllTables = (scenarioIds: number[]) => this.httpPostRequest('scenarios', scenarioIds);

    /**
     * Unloads the files for the scenarios from Snowflake.
     * @param {Array<number>} scenarioIds - Array of scenario id
     * @returns void
     */
    unloadAllTables = (scenarioIds: number[]) => this.httpPostRequest('unload', { scenarioIds });

    /**
     * Loads the scenario configurations into Snowflake.
     * @param {Array<number>} scenarioIds - Array of scenario id
     * @returns void
     */
    loadScenariosConfigs = (scenarioIds: number[]) => this.httpPostRequest('scenarios-configs', scenarioIds);
}